import * as React from 'react';
import classNames from 'classnames';
import { TBannerPlace } from '../../types/adfoxBanner';
import { Banner } from '../../containers/Banner';
import { IAdfoxConstants, PR_RANDOM } from '../adfox/constants';

import styles from './BannersList.css';

interface IBannerListProps {
  place: TBannerPlace;
}

const p1: Record<TBannerPlace, string> = {
  aside: 'crcgk',
  footer: 'crcdp',
  mainpage: 'crcdp',
};

function getConstants(place: TBannerPlace): IAdfoxConstants {
  return {
    p1: p1[place],
    p2: 'fkhh',
    puid15: 'content_part',
    pr: PR_RANDOM,
    pct: 'a',
    pfc: 'a',
    pfb: 'a',
    plp: 'a',
    pli: 'a',
    pop: 'a',
    pt: 'b',
  };
}

export function BannersList({ place }: IBannerListProps) {
  return (
    <ul
      className={classNames(styles['list'], {
        [styles['horizontal']]: place === 'footer',
      })}
    >
      {[0, 1, 2].map(el => (
        <li key={el} className={classNames(styles['item'])}>
          <Banner place={place} constants={getConstants(place)} />
        </li>
      ))}
    </ul>
  );
}
